import React from "react";
import {IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar} from "@ionic/react";

const TransactionUnsuccessful: React.FC = () => {
    return (
        <>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton/>
                    </IonButtons>
                    <IonTitle>Transactie status</IonTitle>
                </IonToolbar>
            </IonHeader>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}>
                <div style={{
                    padding: '20px',
                    borderRadius: '20px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                    <div style={{
                        color: '#D9534F',
                        fontSize: '50px',
                    }}>
                        ✖
                    </div>
                    <h1>Transactie mislukt</h1>
                    <p style={{
                        color: '#555',
                        fontSize: '18px',
                    }}>
                        Er is geen transactie verwerkt.
                    </p>
                </div>
            </div>
        </>
    );
};

export default TransactionUnsuccessful;
